// ** Next imports
import Image from "next/image";

// ** File imports
import Layout, { SEOHead } from "../../layouts/default";
import { FaqTemplate, FaqH, FaqP } from "../../components/support/faqPages";

// ** Img Imports
import morImg from "../../../public/images/mor.jpg";

const MoveOrderRequest = () => (
  <Layout>
    <SEOHead title="Move Order Request" />
    <FaqTemplate title="Move Order Request">
      <FaqH>Making a move? We'll make it smooth.</FaqH>
      <FaqP>
        Transferring your internet service to your new address is easy.
      </FaqP>
      <FaqP>
        Contact us to make changes to your account. All change information
        requests are reviewed by a team member. We will confirm the changes with
        you before they take effect.
      </FaqP>

      <Image
        className="img-fluid"
        placeholder="blur"
        src={morImg}
        alt="Move Order Request"
      />
    </FaqTemplate>
  </Layout>
);

export default MoveOrderRequest;
